"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProdSides = exports.ProdDirectURL = exports.ProdSideKey = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var ProdSideKey;
(function (ProdSideKey) {
    ProdSideKey["C"] = "d9a29f8298f222ecef48a9c5577605a1";
    ProdSideKey["D"] = "764492102925c8411e685ca637ba4fcd";
})(ProdSideKey = exports.ProdSideKey || (exports.ProdSideKey = {}));
var ProdDirectURL;
(function (ProdDirectURL) {
    ProdDirectURL["C"] = "secure-prodc.int.ally.com";
    ProdDirectURL["D"] = "secure-prodd.int.ally.com";
})(ProdDirectURL = exports.ProdDirectURL || (exports.ProdDirectURL = {}));
var defaults = [
    ['dev', /.*-dev/],
    ['cap', /.*-cap/],
    ['fix', /.*-fix/],
    ['qa1', /.*-qa1/],
    ['qa2', /.*-qa2/],
    ['qa3', /.*-qa3/],
    ['psp', /.*-(psp(?:c|d)|prodsupt)/],
    ['dev', /dev\.explore-products-rates/],
    ['qa1', /mod\.explore-products-rates/],
    [
        'local',
        /(^(localhost|0\.0\.0\.0|127\.0\.0\.1)|.*\.gitpod\.9790\.aws\.ally\.com|.*\.gitpod\.services\.ally\.com)/,
    ],
    ['prod', /.*/],
];
var getProdSidesFromCookie = function (prSessionCookie) { return ({
    C: prSessionCookie.includes(ProdSideKey.C),
    D: prSessionCookie.includes(ProdSideKey.D),
}); };
var getProdSidesFromHostname = function (hostname) { return ({
    C: /-(prod|psp)c.int.ally.com$/.test(hostname),
    D: /-(prod|psp)d.int.ally.com$/.test(hostname),
}); };
/**
 * Determines if the app is running in the context of the AOS emulator.
 * If so, `env.pick` will attempt to use `emulator<env>` over `<env>`.
 */
var isEmulatorEnvironment = function () {
    var hasApparition = !!document.querySelector('script[src="/apparition.js"]');
    var hasMirageEnabled = !!window.mirageEnabled;
    return hasApparition && hasMirageEnabled;
};
/**
 * Given a hostname, will return the sides of prod that this host belongs to
 * in the format: `{ C: boolean, D: boolean }
 */
function getProdSides(hostname) {
    var prSessionCookie = js_cookie_1.default.get('pr_session');
    return prSessionCookie
        ? getProdSidesFromCookie(prSessionCookie)
        : getProdSidesFromHostname(hostname);
}
exports.getProdSides = getProdSides;
/**
 * Given a set of Environments (or using the default ones), this will determine
 * the current environment based on the current location's host (by default).
 * Returns an object that contains the environment (`env`) and other booleans
 * for easy environment assertions.
 */
function getEnvironmentInfo(href, envs) {
    if (href === void 0) { href = window.location.href; }
    if (envs === void 0) { envs = defaults; }
    var hostname = new URL(href).hostname;
    var name = (envs.find(function (_a) {
        var _b = __read(_a, 2), x = _b[1];
        return x.test(hostname);
    }) || ['prod'])[0];
    var isDev = name === 'dev';
    var isLocal = name === 'local';
    var isDevLike = isDev || isLocal;
    var isEmulator = isEmulatorEnvironment();
    var isQA = !!name.startsWith('qa') || name === 'fix';
    var isProd = !isQA && !isDev && !isLocal;
    var prod = getProdSides(hostname);
    var pick = function (choices) {
        if (isEmulator) {
            var key = isProd ? 'emulatorProd' : 'emulatorLLE';
            if (key in choices)
                return choices[key];
        }
        return name in choices ? choices[name] : choices.prod;
    };
    return {
        isDev: isDev,
        isDevLike: isDevLike,
        isEmulator: isEmulator,
        isLocal: isLocal,
        isProd: isProd,
        isQA: isQA,
        name: name,
        pick: pick,
        prod: prod,
    };
}
exports.default = getEnvironmentInfo;
//# sourceMappingURL=index.js.map